import React from 'react'
import { Popconfirm } from 'antd'
import './SigPopconfirm.less'

const SigPopconfirm = (props) => (
  <Popconfirm overlayClassName="SigPopconfirm" {...props} />
)

export default SigPopconfirm
